<template>
  <div class="projects-header">
    <div class="projects-header__title">projects <div class="projects-header__button button--add-new" v-on:click="toggleAddingProject">add new</div></div>
    <div class="projects-header__list">
      <div class="projects-header__project" v-for="project in this.projects" v-bind:key="project.id">{{project.title}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["projects"],
  methods: {
    toggleAddingProject() {
      this.$emit("toggle-adding-project");
    }
  }
};
</script>

<style lang="scss">
.projects-header {
  font-size: 14px;
  font-weight: 700;
  display: grid;
  justify-content: end;
  margin-bottom: 70px;
  text-align: right;
  color: $mono-53;
  &.is-adding-project {
    + .projects {
      pointer-events: none;
      opacity: 0.5;

      filter: blur(2px);
    }
  }
  &__title {
    font-style: italic;
    display: inline-block;
    color: $mono-53;
  }
  &__project {
    display: inline-block;
    text-transform: lowercase;
    color: $mono-33;
    &:not(:first-of-type) {
      &:before {
        padding: 0 5px;
        content: "\2022";
      }
    }
  }
  &__button {
    display: inline-block;
    color: $mono-33;
    &:before {
      padding: 0 5px;
      content: "\2022";
    }
  }
}
</style>
